import React , { Component } from 'react';
import ReactDOM from 'react-dom';
import LoggedInPage from '../../views/core/LoggedInPage';
import AccordionLayout from './AccordionLayout';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import Loader from 'react-loader-spinner';
import ViewSolutionLayout from './ViewSolutionLayout';

class Diagnostic extends LoggedInPage{
    constructor(props){
        super(props)
        this.state = {
            dataLoaded:false,
            dataUpdated:false,
            testModalView: "", 
            testModalShow: false, 
            testModalContent: "loading"
        }

        this.loadDiagnostic=this.loadDiagnostic.bind(this);
        this.showSolnModal = this.showSolnModal.bind(this);
    }

    componentDidMount(){
        ///this.getReportTab();
    }
    

    getColor(percentage, status){
        var percArr= window.diagnosticColor || ['#9c9e9f','#F73E21','#fb9100','#7cb045'];
        var clrval = percArr[1];
        if(status && status.toUpperCase() === "NEW"){
            clrval = percArr[0];
        }else if(percentage>=41 && percentage <=70){
            clrval = percArr[2];
        }else if(percentage>70 && percentage <=100){
            clrval = percArr[3];  
        }
        return clrval;
    }

    loadsubTopicasTile(diagdata){
          var me=this;
          if(diagdata!=null){
            if(diagdata.subTopics){
                return (
                    Object.values(diagdata.subTopics).map(function (diagsubTopics, index) {
                    var colorStyle = {
                        backgroundColor:me.getColor(diagsubTopics.percentage, diagsubTopics.status),
                        color:'white'
                    }
                    return(
                     <div key={index} className="subtopiccont" style={colorStyle}>
                       <div className="subtopbox">
                        <div>{diagsubTopics.subTopicName}</div>
                        </div>
                     </div> 
                    )
                }))
            }
          }
    }

    loadsubTopicasBanner(diagdata){
       let borStrg = this.isMobile() ? "1rem solid " : "1.5rem solid ";

        var me=this;
          if(diagdata!=null){
            if(diagdata.subTopics){
                return (
                    Object.values(diagdata.subTopics).map(function (diagsubTopics, index) {
                    var colorStyle = {
                        border: "1px solid "+ me.getColor(diagsubTopics.percentage, diagsubTopics.status),
                        borderLeft: borStrg+ me.getColor(diagsubTopics.percentage, diagsubTopics.status),
                    }
                    return(
                     <div key={index} className="subtopiccontBan" style={colorStyle}>
                       <div className="subtopbox">
                        <div>{diagsubTopics.subTopicDesc || diagsubTopics.subTopicName}</div>
                        </div>
                     </div> 
                    )
                }))
            }
          }
  }

   
    showSolnModal(data, idx){
      console.log("lalalal data ::" , data);
      let accessId = this.props.reportData.accessId;
      let classId = this.props.reportData.classId;

      let diagnosticType = this.props.reportData.diagnosticType;
      let benchMarkType =  this.props.reportData.benchMarkType;

      let topicId = data.topicId || 0;
      let topicName = data.topic || "";

      ReactDOM.render(<ViewSolutionLayout accessId={accessId} classId={classId} benchMarkType={benchMarkType} diagnosticType={diagnosticType} topicId={topicId} topicName={topicName} unMount={this.hideSolnModal} />, document.getElementById("diag_view_solns_modal"));
    }

    hideSolnModal(){
      ReactDOM.render(null, document.getElementById("diag_view_solns_modal")); 
    }


    getTitleContent(diagdata){
        var me=this;
          return diagdata.topic;
    }

    getBodyContent(diagdata,index){
          var me=this;
          //console.warn("lalalal 3 : ", diagdata)
          return (
            <div className="faqcnt"> 
        
            {(() => {
              if(diagdata.status === "COMPLETED"){
                return(
                            <div className="float-right bottomBtns">
                                 <button type="button" className="btn btn-primary largeBtn" onClick={me.showSolnModal.bind(this,diagdata,index)}>
                                 View Solutions
                                 </button>
                             </div>
                )
              }
            })()}

             <div className="clearfix"></div>
            <div className="flex-containerBan">
                 {me.loadsubTopicasBanner(diagdata)}
                 </div>

                 {/* <div className="flex-container">
                 {me.loadsubTopicasTile(diagdata)}
                 </div> */}

             </div>
          )
    }

     loadDiagnostic(){
      console.log("lalalala 2::",this.props);

        var me=this;
        
        if (me.props.reportData && me.props.reportData!=null) {
            var benchMarkData = me.props.reportData.benchMarkData;

            if(benchMarkData!=null){
                if(benchMarkData.diagnostic_report){
                    return (
                        <div className="diagnosticRep">
                            <div className="">
                                {benchMarkData.diagnostic_report.map(function (diagdata, index) {
                                    return (
                                        <AccordionLayout key={index} titleContent={me.getTitleContent(diagdata)} bodyContent={me.getBodyContent(diagdata,index)}></AccordionLayout>
                                    );
                                })}
        
                            </div>
                        </div>
                    )
                }
            }
        } else {
            return (
                <div className="text-center loadingAnim">
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height="100"
                    width="100"
                />
            </div>
            )
        }
     }

 

    render(){
        var me=this;
        return(
            <div>
               {me.loadDiagnostic()}

               <div id="diag_view_solns_modal" style={{zIndex:3}}></div>
               
            </div>
        )
    }
}

export default Diagnostic;


// WEBPACK FOOTER //
// ./src/vendors/mindstretcher/Diagnostic.js